import React from 'react';
import { experience } from '../data/site';
export function Experience() {
  return <section id="experience" className="border-b border-rule" data-id="element-31" data-mp="23svofi69cprc">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-20 md:py-24" data-id="element-32" data-mp="23qiyoiu9db3q">
        <div className="max-w-2xl" data-id="element-33" data-mp="1yuaq5oakgg5j">
          <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink" data-id="element-34" data-mp="1yr6bty3e0415">
            Experience that connects strategy to execution
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-35" data-mp="2rhofp1bxq9fm">
            My work spans growing businesses, mission-driven organizations, and complex government
            programs. The common thread is helping people turn priorities into coordinated action.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-10 md:gap-10 lg:gap-12" data-id="element-36" data-mp="2cke4lt37f5kf">
          {experience.map(item => <article key={item.org} className="flex flex-col border-t-2 border-ink pt-6 md:pt-7" data-id="element-37" data-mp="162r1hov7a9w5">
              <p className="text-xs uppercase tracking-[0.14em] font-medium text-clay" data-id="element-38" data-mp="toq0r2eb2kif">
                {item.org}
              </p>
              <h3 className="mt-4 font-serif text-xl leading-snug text-ink md:min-h-[3.5rem]" data-id="element-39" data-mp="yn15wztno6ub">
                {item.title}
              </h3>
              <p className="mt-4 text-[0.9375rem] leading-relaxed text-ink-soft" data-id="element-40" data-mp="oq6bot4f0slu">{item.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}